var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Collapsible',{attrs:{"open":_vm.isVisible}},[_c('Alert',{staticClass:"mb",attrs:{"color":_vm.isError ? 'danger' : _vm.color}},[_vm._v("\n        "+_vm._s(_vm.message)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }